import { FC } from 'react'

import {
  ImageExercise,
  OnResponseSubmit,
  StepResponse,
} from '../../../types/Exercise'
import { useSwiperSlide } from 'swiper/react'
import { ResponseStatus } from '../../../common/utils/exercise'

interface ImagePostProps {
  id: number
  data: ImageExercise
  onResponseSubmit: OnResponseSubmit
  stepResponse?: StepResponse
}

const Image: FC<ImagePostProps> = ({
  id,
  data,
  onResponseSubmit,
  stepResponse,
}) => {
  const swiperSlide = useSwiperSlide()
  const baseUrl = process.env.REACT_APP_BASE_URL

  if (swiperSlide.isActive && !stepResponse) {
    onResponseSubmit(id, ResponseStatus.COMPLETE)
  }

  return <img src={`${baseUrl}/${data.src}`} alt="TBD" />
}

export default Image
